import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../Layout';

const entryPoints = [
  {
    title: 'Leaders today',
    description: 'See the current First Presidency, Quorum of the Twelve, and other leaders.',
    to: `/leaders?date=${moment().format('YYYY-MM-DD')}`,
  },
  {
    title: 'Start in 1830',
    description: "Start at the church's founding and step forward one change at a time.",
    to: '/leaders',
  },
  {
    title: 'Talk trends',
    description: 'See how often topics come up in conference talks. Satan drops off after the 1970s, and "covenant path" takes off in 2018.',
    to: `/stats?${['temple', 'Satan', 'pioneer', 'social media', 'covenant path']
      .map(term => `terms[]=${encodeURIComponent(term)}`).join('&')}`,
  },
];

const Home = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl">
        <p className="text-lg">
          Every prophet and apostle from 1830 to today. Pick a date to see who
          was serving, then step through the changes one at a time.
        </p>
        <div className="grid gap-4 md:grid-cols-3 mt-6">
          {entryPoints.map(entryPoint => (
            <Link
              key={entryPoint.title}
              to={entryPoint.to}
              className="block p-4 rounded-lg shadow-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700"
            >
              <h2 className="text-lg font-bold">{entryPoint.title}</h2>
              <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
                {entryPoint.description}
              </p>
            </Link>
          ))}
        </div>
        <p className="mt-6 text-sm text-gray-600 dark:text-gray-400">
          Colored cards on the Leaders page mark changes on the selected date.
          Click any date to jump there.
        </p>
      </div>
    </Layout>
  );
};

export default Home;
